"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collection = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
exports.collection = joi_1.default.object({
    schema: joi_1.default.string(),
    id: joi_1.default.string(),
    url: joi_1.default.string(),
    uuid: joi_1.default.string(),
    instanceId: joi_1.default.string(),
    revision: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string(),
    }),
    job: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string(),
    }),
    form: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string(),
    }),
    createdAt: joi_1.default.string(),
    collectedAt: joi_1.default.string(),
    collectedBy: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string(),
    }),
    collectedWith: joi_1.default.string(),
    updatedAt: joi_1.default.string(),
    updatedBy: joi_1.default.object({
        id: joi_1.default.string(),
        url: joi_1.default.string(),
    }),
    fields: joi_1.default.array().items(joi_1.default.object({
        field: joi_1.default.string(),
        name: joi_1.default.string(),
        type: joi_1.default.string(),
        value: joi_1.default.any(),
    })),
    captures: joi_1.default.array().items(joi_1.default.object({
        explanation: joi_1.default.string().default('All the capture information goes here'),
    })),
    measurements: joi_1.default.object({
        explanation: joi_1.default.string().default('All the measurement information goes here'),
    }),
    brightnessCorrections: joi_1.default.object({
        explanation: joi_1.default.string().default('All the brightness adjustments information goes here'),
    }),
    cropParameters: joi_1.default.object({
        explanation: joi_1.default.string().default('All the image crop information goes here'),
    }),
});
//# sourceMappingURL=collection.json.def.js.map